<vl-form-grid mod-stacked class="product-lines">
    <vl-column v-for="(productLine, index) in paymentSession.productLines" >
        <div :class="{'product-line__totals': true, 'product-line__top-corner': index === 0 }">
            <div class="product-line__totals__label">{{ productLine.description }}</div>
            <div class="product-line__totals__total">{{ formatCurrency(productLine.price) }}</div>
        </div>
    </vl-column>
    <vl-column v-for="(vatValue, vatRate) in paymentSession.vatByRate" :key="vatRate">
        <div class="product-line__totals">
            <div class="product-line__totals__label">Btw {{ vatRate }}&percnt;</div>
            <div class="product-line__totals__total">{{ formatCurrency(vatValue) }}</div>
        </div>
    </vl-column>
    <vl-column>
        <div class="product-line__totals product-line__sum product-line__bottom-corner">
            <div class="product-line__totals__label">Totaal</div>
            <div class="product-line__totals__total">{{ formatCurrency(paymentSession.totalAmountInclVat) }}</div>
        </div>
    </vl-column>
</vl-form-grid>